/**
  * теперь этот файл/поток будет кодироваться в UTF-8
  */
import './style.css';
import './modules/userStore'
import './modules/catalogStore'
import './modules/basketStore'
// components include after module
//
import 'germes.multibasket.src.components.sku'
import 'germes.multibasket.src.components.sku_input'
import 'germes.multibasket.src.components.sku_labels'
import 'germes.multibasket.src.components.sku_price'
import 'germes.multibasket.src.components.sku_price_sum'
import 'germes.multibasket.src.components.sku_progress_bar'
import 'germes.multibasket.src.components.sku_settings_bar'
//
import 'germes.multibasket.src.components.cart'
